import { S2P_ELEVATE_ROCKLINE_PROGRAM } from "@/data/s2pElevateRockline";
import { S2PElevateDeck } from "@/pages/S2PElevateAI";

const S2PElevateAIRockline = () => (
  <S2PElevateDeck
    program={S2P_ELEVATE_ROCKLINE_PROGRAM}
    config={{
      storageNamespace: "s2p-elevate-ai-rockline-v35",
      analyticsVariant: "rockline",
      seoTitle: "AI Tools & Workflows for Rockline Leaders: Serve2Perform ELEVATE",
      seoDescription: "A private, five-session Serve2Perform ELEVATE workshop on complex prompting, choosing the right work and tool, controlling AI agents, and improving them with evidence.",
      seoKeywords: [
        "Serve2Perform",
        "ELEVATE",
        "Rockline",
        "Microsoft Copilot",
        "AI workflows",
        "AI agents",
        "Jobs to be Done",
        "AI metric loops",
      ],
      robots: "noindex, nofollow",
      coverAudience: null,
      coverSessionTitles: [
        "Complex Prompting Made Easy",
        "Pick the Right Work for AI",
        "Pick the Best AI Tool For the Job",
        "Set Up and Run AI Agents",
        "Improve AI Agents",
      ],
      contentsEyebrow: "Serve2Perform ELEVATE · Rockline",
      showcaseSupportLabel: "Delivery paths to confirm",
      finishCtaHref: "/s2p-elevate-ai-builder",
      finishCtaLabel: "Open the AI Builder Playbook",
    }}
  />
);

export default S2PElevateAIRockline;
